<style>
  .tips-box{
      line-height: inherit;
      padding: 14px 20px;
      vertical-align: middle;
      color: #003b80;
      border: 1px solid #428bca;
      border-radius: 2px;
      background: #f5f5f5;
      margin-bottom: 10px;
  }
  .tips-box p{
      background-color: #fff;
      line-height: 30px;
      padding-left: 10px;
      box-shadow: 2px 2px 5px 0 rgba(0,0,0,.2);
  }
</style>
<template>
  <div class="tips-box">
    <p>1、 国内短信由签名+正文组成，签名符号为【】（注：全角），发送短信内容时必须带签名;</p>
    <p>2、 短信签名和模板提交后，预计2小时完成审核。审核时间：周一至周日9:00-23:00(法定节假日正常服务)。</p>
  </div>
</template>
<script>
export default {
  name: "tips",
  data(){
    return{};
  },
  created(){},
  methods: {},
  components: {}
}
</script>
  




// WEBPACK FOOTER //
// src/components/message/tips.vue